"use client"
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/free-mode"
import Link from "next/link"
import Title from "../Title/Title"

import type { SwiperOptions } from "swiper/types"

type Service = {
  url: string
  image: string
  title: string
  description: string
}

type DefaultItem = {
  // Define properties as needed for default rendering
  [key: string]: unknown
}

type SwiperProps = {
  data: Array<Service | DefaultItem>
  navigation?: {
    prevEl: string
    nextEl: string
  }
  swiperOptions?: SwiperOptions
  type?: string // add type to determine rendering
}

const Swiper = ({
  data,
  navigation,
  swiperOptions = {},
  type,
}: SwiperProps) => {
  return (
    <SwiperComponent
      modules={[Navigation]}
      navigation={navigation}
      {...swiperOptions}
    >
      {type === "about-services"
        ? (data as Service[]).map((service, idx) => (
            <SwiperSlide key={idx}>
              <Link href={service.url} className="card group ">
                <figure className="flex rounded-sm flex-col xl:flex-row gap-6 bg-white p-8 3xl:p-12 border border-[--color-gray] h-full">
                  <div className="image-wrap overflow-hidden xl:min-w-[220px]  h-auto relative">
                    {/* <div className="swiper-img"></div> */}
                    <img
                      src={service.image}
                      alt={service.title}
                      width={280}
                      height={260}
                      loading="lazy"
                      decoding="async"
                      fetchPriority="low"
                      className=" object-cover max-h-[260px] 3xl:max-h-[400px] h-fit m-auto  transition-transform duration-500 group-hover:scale-110 p-16 hover:before:content-['']  "
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <figcaption className="flex flex-col  justify-between xl:items-end">
                    <div className="">
                      <Title
                        title={service.title}
                        type="h4"
                        className="uppercase 2xl:text-[34px] 3xl:text-[48px]"
                      />
                      <p className="mt-4 xl:mt-6 text-[16px]  3xl:text-[28px] text-[--color-muted] ">
                        {service.description}
                      </p>
                    </div>
                    <div className="bg-[--color-gray] rounded-sm  flex h-[62px] w-[62px] mt-4 items-center justify-center justify-self-start svg-wrapper transition-bg ">
                      <svg
                        width="18"
                        height="10"
                        viewBox="0 0 18 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.483 0.622513L17.3014 4.44089C17.5357 4.6752 17.5357 5.0551 17.3014 5.28942L13.483 9.10779C13.2487 9.34211 12.8688 9.34211 12.6345 9.10779C12.4001 8.87348 12.4001 8.49358 12.6345 8.25927L15.4286 5.46515H0.828516C0.497145 5.46515 0.228516 5.19653 0.228516 4.86515C0.228516 4.53378 0.497145 4.26515 0.828516 4.26515H15.4286L12.6345 1.47104C12.4001 1.23673 12.4001 0.856828 12.6345 0.622513C12.8688 0.388199 13.2487 0.388199 13.483 0.622513Z"
                          fill="black"
                        />
                      </svg>
                    </div>
                  </figcaption>
                </figure>
              </Link>
            </SwiperSlide>
          ))
        : data.map((item, idx) => (
            <SwiperSlide key={idx}>
              {/* TODO: Implement default rendering for DefaultItem */}
            </SwiperSlide>
          ))}
    </SwiperComponent>
  )
}

export default Swiper
